export default "__VITE_ASSET__C8Ma8TSl__"